import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { fetchPropertyCounts } from 'src/store/actions/properties';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import Loader from 'src/components/Loader';
import {
  PropertyNotesProvider,
  usePropertyNotesActionsFromContext,
  usePropertyNotesDataFromContext,
} from 'src/pages/Property/Context/PropertyNotesProvider';

const PropertyNotesInner = ({ property }: any) => {
  const dispatch = useDispatch();
  const loader = useSelector(selectPRLoader);
  const user = useSelector(selectAuthenticatedUser);

  const { notes, loadingNotesDocs } = usePropertyNotesDataFromContext();

  const { fetchNotes, saveNote, updateNote, deleteNote, clearSearch } =
    usePropertyNotesActionsFromContext();

  useEffect(() => {
    clearSearch();
    fetchNotes(property.propertyId);
  }, [property.propertyId]);

  const handleFetchPropertyCounts = () => {
    dispatch(
      fetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)
    );
  };

  const handleSaveNote = async (note: any) => {
    await saveNote(note, property.id);

    if (!note.id) {
      handleFetchPropertyCounts();
    }
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, property.id);
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, property.id);

    handleFetchPropertyCounts();
  };

  return loader || loadingNotesDocs ? (
    <Loader />
  ) : (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={property.name}
      from="properties"
    />
  );
};

const PropertyNotes = ({ property }: any) => {
  return (
    <PropertyNotesProvider>
      <PropertyNotesInner property={property} />
    </PropertyNotesProvider>
  );
};

export default PropertyNotes;
